import { useDispatch, useSelector } from "react-redux";
import useLang from "../../hooks/use-lang";
import { useMemo } from "react";
import CommonBlock from "../../wrappers/block/CommonBlock";

export default function OurSustainabilityBlock() {
    const dispatch = useDispatch();
    const { our_sustainability_practises } = useSelector((state) => state.app);
    const LangUtils = useLang();

    const formattedData = useMemo(() => {
        return our_sustainability_practises.map((data) => ({
            id: data.id,
            title: LangUtils.getLangValue(data, "title"),
            subtitle: LangUtils.getLangValue(data, "subtitle"),
            description: LangUtils.getLangValue(data, "description"),
            button_text: LangUtils.getLangValue(data, "button_text"),
            external_url: data.external_url,
            image_url: data.section_image_1,
        }));
    }, [our_sustainability_practises, LangUtils]);

    return (
        <div>
            {formattedData?.map((single, key) => (
                <div key={key}>
                    <CommonBlock
                        spaceTopClass="pt-50"
                        spaceBottomClass="pb-100"
                        title={single.title}
                        subtitle={single.subtitle}
                        description={single.description}
                        buttonText={single.button_text}
                        externalUrl={single.external_url}
                        imageUrl={single.image_url}
                        imagePosition={key % 2 === 0 ? "left" : "right"}
                    />
                </div>
            ))}
        </div>
    );
}
